/* Health Assessment Quiz v3 — Martin Clinic */
(function(){

var isCanada=window.location.hostname.indexOf('martinclinic.com')!==-1&&window.location.hostname.indexOf('us.martinclinic.com')===-1;
var KLAVIYO_PUBLIC_KEY=isCanada?'MvUqmM':'X4AEgj';
var KLAVIYO_LIST_ID=isCanada?'HrjwTB':'SkDngR';
var DEBUG_KLAVIYO=window.location.search.indexOf('debug_klaviyo=1')!==-1;
var STORAGE_KEY='ha3_progress';

var gender=null,step=0,sections=[],answers={},quizResults={};

function setProgress3(pct){
  var el=document.getElementById('ha3-pf');
  if(el)el.setAttribute('style','width:'+pct+'% !important');
}

var base=[
  {id:'thyroid',name:'Thyroid',sub:'Check every symptom that applies to you.',
   qs:['Are you tired all the time?','Do you have a hard time losing weight?','Do you suffer from depression or anxiety?','Is your hair thinning, or are you losing more hair than you should?','Do you put on weight easily?','Are your hands & feet cold all the time?','Do you have low sex drive?','Do you have trouble concentrating or memory loss?','Do you have voice changes?','Are you always trying to clear your throat?','Do you have an irregular heartbeat?','Do you have swelling around the neck area?','Do you have dry skin?','Do you suffer from constipation?'],
   weights:[3,3,1,3,3,1,1,2,1,1,1,1,1,1]},
  {id:'insulin',name:'Insulin',sub:'Check every symptom that applies to you.',
   qs:['Do you carry extra weight in the belly area?','Do you have foggy or fuzzy thinking?','Do you have high blood pressure?','Do you have low energy?','Do you suffer from heartburn or acid reflux?','Do you have low sex drive?','Are you tired after eating?','Do you have skin tags?','Do you have trouble sleeping?','Do you feel unwell if you haven\'t eaten for several hours?','Do you have swollen ankles, circulation problems in your lower legs, or leg cramps?','Do you have high triglycerides or low HDL?','Have you been told your A1C is high or that you\'re pre-diabetic?','Do you have gout or high uric acid levels?','Do you have carpal tunnel syndrome or pain in the Achilles tendons?'],
   weights:[3,2,2,2,1,1,2,3,1,2,2,3,3,3,2]},
  {id:'b12',name:'B12',sub:'Check every symptom that applies to you.',
   qs:['Do you have digestive issues?','Do you smoke?','Do you have low energy or get tired during the day?','Are you constipated?','Do you suffer from depression?','Do you suffer from dizziness?','Do you suffer from headaches?','Do you have inflammation of the tongue?','Do you have trouble breathing or shortness of breath?','Do you have memory loss?','Do you have heart palpitations?','Do you have ringing in your ears?','Do you have numbness around your mouth, fingers, or toes?','Are you on anti-gout, anticoagulant, or diabetic medication?','Do you eat red meat more than once a week?'],
   weights:[1,2,2,1,1,2,1,3,2,2,2,2,3,2,-3]},
  {id:'cortisol',name:'Cortisol',sub:'Check every symptom that applies to you.',
   qs:['Do you suffer from brain fog?','Do you suffer from insomnia?','Do you have weight gain around the middle?','Do you suffer from depression or anxiety?','Do you suffer from hair loss?','Do you suffer from acne?','Do you get dizzy when standing?','Do you have nausea, vomiting, or diarrhea?','Do you crave sugar or salt?','Do you have loss of appetite?','Do you get sick often (colds, flu, etc.)?','Do you have allergies or food intolerances?','Are you exhausted?','Have you been diagnosed with fibromyalgia?','Do you have low blood sugar?','Is your thyroid sluggish?'],
   weights:[2,3,2,1,1,1,2,1,2,1,1,1,3,2,2,2]},
  {id:'leakygut',name:'Leaky Gut',sub:'Check every symptom that applies to you.',
   qs:['Have you taken antibiotics in the last few years?','Do you get recurring urinary tract infections?','Were you on antibiotics often as a child?','Do you have recurring diarrhea, constipation, or abdominal pain?','Do you have a white tongue?','Do you have bad breath?','Do you have chronic sinusitis?','Do you have memory loss?','Do you have mood swings?','Do you have rectal itching?','Do you have a burning tongue?','Do you get athlete\'s foot, thrush, or nail fungus?','Do you regularly take NSAIDs (Tylenol, Advil, aspirin)?','Are you on or have you taken birth control pills?','Do you have skin conditions like eczema, acne, rashes, hives, or psoriasis?','Do you have an autoimmune disease?'],
   weights:[2,2,2,2,3,2,1,1,1,2,2,3,2,1,3,3]},
  {id:'vitamind',name:'Vitamin D',sub:'Check every symptom that applies to you.',
   qs:['Do you work indoors?','Are you frequently sick?','Are you fatigued or tired?','Do you have bone, joint, or muscle pain?','Do you have digestive issues?','Do you suffer from depression?','Do you have poor memory?','Do you have bone loss or osteoporosis?','Do you have muscle weakness?','Do you get sunlight on your arms, legs, and face for at least 20 minutes every day?','Do you take at least 4,000 IU of vitamin D3 daily?'],
   weights:[2,2,2,3,1,2,2,3,2,-3,-3]}
];

var estrogenSec={id:'estrogen',name:'Estrogen',sub:'These questions are for women only.',
  qs:['Are you depressed?','Do you have mood swings?','Do you have trouble falling asleep?','Do you have hot flashes?','Do you have night sweats?','Do you have reduced stamina?','Do you have dry eyes, skin, or vaginal dryness?','Do you have bloating?','Do you have heart palpitations?','Do you have low bone density?','Do you have painful breasts?','Do you have increased breast size?','Do you have water retention?','Do you have pelvic cramps?','Do you have decreased sex drive?','Do you have headaches?','Do you have weight gain?','Do you have cold hands and feet?','Do you have a sluggish metabolism?','Do you have hair loss?','Do you have PMS?','Do you have fatigue?','Do you have bladder issues?','Do you have heavy or irregular periods?'],
  weights:[2,2,2,3,3,1,2,1,2,2,2,1,2,2,2,1,2,1,2,2,2,2,1,3]};

var products={
  thyroid:{name:'Thyroid Support Formula',teach:'Your thyroid doesn\'t act alone. It takes orders from the brain. And 90% of what your thyroid makes is T4 \u2014 the inactive form. Your body has to convert T4 into T3, the active form you need for energy, metabolism, and fat burning. That conversion happens in your liver, gut, and muscles. If any of those are off \u2014 or if cortisol or estrogen are too high \u2014 the conversion breaks down. Most doctors never look here. Normal labs don\'t mean a normal life.',why:'Our Thyroid Support Formula was built knowing the whole system matters \u2014 iodine, L-tyrosine, selenium, L-carnitine, and resveratrol work together to support hormone production, T4-to-T3 conversion, and energy.'},
  insulin:{name:'Blood Sugar / Insulin Support Formula',teach:'Inside your body, you only need about one teaspoon of glucose in your blood at any given time. When blood sugar spikes from carbs, sugar, or stress, insulin rushes in to remove it. Over time, your cells stop listening to insulin. Your body has to make more and more just to do the same job. That\'s insulin resistance \u2014 and it shows up long before your doctor flags anything.',why:'Our Blood Sugar / Insulin Support Formula helps your cells respond to insulin properly, stabilize blood sugar, reduce cravings, and support healthy metabolic function.'},
  b12:{name:'B12 Sublingual',teach:'Low B12 can cause deep exhaustion \u2014 the kind where you wake up already drained. Add brain fog, numbness, heart palpitations, dizziness, and memory problems, and you see why B12 is so critical. Your doctor\'s blood test may show normal. That only shows what\'s floating in your blood \u2014 not what\'s getting inside your cells.',why:'Most B12 supplements use cyanocobalamin \u2014 a synthetic form your body struggles to use. Our B12 Sublingual uses methylcobalamin, the real natural form, delivered under the tongue for direct absorption.'},
  cortisol:{name:'Cortisol Control Formula',teach:'Cortisol isn\'t a bad hormone. The problem is timing. Cortisol should be high in the morning and low at night. Stress, poor sleep, and blood sugar swings flip that rhythm completely. You end up wired at night and dragging all day. You wake at 3AM with your heart racing. And your doctor\'s tests come back normal because they\'re testing levels \u2014 not timing.',why:'Cortisol Control uses 8 clinically-studied ingredients \u2014 including Relora, phosphatidylserine, ashwagandha, and L-theanine \u2014 to lower elevated nighttime cortisol and restore your natural sleep rhythm.'},
  leakygut:{name:'Probiotic Complex',teach:'Most people with leaky gut have zero digestive symptoms. Instead it shows up as skin issues, brain fog, joint pain, mood swings, food sensitivities, and an immune system that won\'t cooperate. Your gut lining is supposed to be a tight barrier. When it breaks down, bacteria, yeast, and undigested food particles enter your bloodstream and trigger inflammation everywhere.',why:'Our Probiotic Complex delivers 50 billion CFU of soil-based, broad-spectrum strains to rebuild your microbiome, plug the holes in your gut lining, and crowd out the bad bacteria causing the trouble.'},
  estrogen:{name:'Hormonal Support Formula',teach:'Estrogen dominance means your estrogen is out of balance. Xenoestrogens in plastics, lotions, and even drinking water act just like real estrogen in your body. Pair that with high insulin from too many carbs \u2014 and you have a perfect storm. Weight gain, irregular periods, mood swings, poor sleep, and hair loss all follow.',why:'Our Hormonal Support Formula is built around DIM \u2014 a powerful compound from cruciferous vegetables that promotes healthy estrogen metabolism, shifting your body toward the good metabolites and away from the harmful ones.'},
  vitamind:{name:'Liquid Vitamin D3 + K2',teach:'Every single tissue in your body has a vitamin D receptor. When vitamin D is low, everything suffers. And 70% of North Americans are low. Most people spend 90% of their time indoors. A 70-year-old makes four times less vitamin D from sunlight than a 20-year-old.',why:'Our Liquid D3 + K2 uses vitamin D3 \u2014 three times more effective than D2 \u2014 paired with MK-7, the most absorbable form of K2. One tiny drop delivers 1,000 IU. Most people need just 4 drops a day.'},
  navitol:{name:'Navitol Ultra Strength',teach:'Pine bark does three things: it raises nitric oxide so blood flows freely to every cell, shuts off your body\'s inflammation master switch, and boosts glutathione \u2014 your body\'s own detox and immune fuel. The result is more energy, sharper thinking, less pain, and stronger immunity across every system.',why:'Navitol Ultra Strength uses the highest-concentration pine bark extract available \u2014 over 80% OPCs. Water-soluble, crosses the blood-brain barrier, and rapidly absorbed throughout your entire body.'}
};

/* ─── Video recommendations per quiz section ─── */
var contentBySection={
  thyroid:[
    {type:'video',id:'k18dTvXTRDw',title:'Thyroid Numbers vs. Symptoms: Which Matters Most?',meta:'Dr. Martin \u2022 Video'},
    {type:'video',id:'jePlPc5nfy8',title:'Feeling Tired? Your Thyroid Could Be Why!',meta:'Dr. Martin \u2022 Video'},
    {type:'podcast',title:'Your Thyroid: The Missing Piece of the Puzzle',meta:'Dr. Martin \u2022 Ep. 1724',audio:'https://traffic.libsyn.com/secure/martinclinic/1724-the_doctor_is_in.mp3?dest-id=262893'}
  ],
  insulin:[
    {type:'video',id:'xbmuT-sDj9U',title:'Insulin: The Hidden Health Crisis Society Ignores',meta:'Dr. Martin \u2022 Video'},
    {type:'video',id:'dvGr7McZShQ',title:'Fueling the Fire: Insulin\u2019s Role in Cancer Growth',meta:'Dr. Martin \u2022 Video'},
    {type:'podcast',title:'Triglycerides 101: Why Your Numbers Matter',meta:'Dr. Martin \u2022 Ep. 1780',audio:'https://traffic.libsyn.com/secure/martinclinic/1780-the_doctor_is_in.mp3?dest-id=262893'}
  ],
  b12:[
    {type:'video',id:'jePlPc5nfy8',title:'Feeling Tired? Your B12 Deficiency Could Be Why!',meta:'Dr. Martin \u2022 Video'},
    {type:'video',id:'6jTsRrXpcEE',title:'B12: The Energy Vitamin Your Body Is Missing',meta:'Dr. Martin \u2022 Video'},
    {type:'podcast',title:'B12 Deficiency: The Silent Epidemic',meta:'Dr. Martin \u2022 Ep. 1766',audio:'https://traffic.libsyn.com/secure/martinclinic/1766-the_doctor_is_in.mp3?dest-id=262893'}
  ],
  cortisol:[
    {type:'video',id:'UHWihYM-h7s',title:'High Cortisol: Can\u2019t Sleep & Feel Wired!',meta:'Dr. Martin \u2022 Video'},
    {type:'video',id:'M8L4xmTLP-8',title:'Cortisol Effects on Hunger & Weight Gain',meta:'Dr. Martin \u2022 Video'},
    {type:'podcast',title:'The Cortisol Curve: From Helper to Harmful',meta:'Dr. Martin \u2022 Ep. 1671',audio:'https://traffic.libsyn.com/secure/martinclinic/1671-the_doctor_is_in.mp3?dest-id=262893'}
  ],
  leakygut:[
    {type:'video',id:'65NZErMgLxo',title:'Leaky Gut = Leaky EVERYTHING',meta:'Dr. Martin \u2022 Video'},
    {type:'video',id:'HntboK8nVsA',title:'Heal Your Gut',meta:'Dr. Martin \u2022 Video'},
    {type:'podcast',title:'Gut Feeling: The Microbiome Connection',meta:'Dr. Martin \u2022 Ep. 1775',audio:'https://traffic.libsyn.com/secure/martinclinic/1775-the_doctor_is_in.mp3?dest-id=262893'}
  ],
  estrogen:[
    {type:'video',id:'olnqA1nbVFE',title:'Why I NEVER Give Women Estrogen: Progesterone is Key!',meta:'Dr. Martin \u2022 Video'},
    {type:'video',id:'IVljYaozbww',title:'Lower Insulin & Estrogen: The Key To Fighting Cancer',meta:'Dr. Martin \u2022 Video'},
    {type:'podcast',title:'Estrogen Dominance: What Every Woman Should Know',meta:'Dr. Martin \u2022 Ep. 1761',audio:'https://traffic.libsyn.com/secure/martinclinic/1761-the_doctor_is_in.mp3?dest-id=262893'}
  ],
  vitamind:[
    {type:'video',id:'aRyUyldCVqk',title:'Vitamin D Deficiency: Uncovering Hidden Health Issues',meta:'Dr. Martin \u2022 Video'},
    {type:'video',id:'phizTDrW3qg',title:'Vitamin D: Boost Memory and Fight Dementia!',meta:'Dr. Martin \u2022 Video'},
    {type:'podcast',title:'Vitamin D: The Sunshine Vitamin You\u2019re Not Getting Enough Of',meta:'Dr. Martin \u2022 Ep. 1626',audio:'https://traffic.libsyn.com/secure/martinclinic/1626-the_doctor_is_in.mp3?dest-id=262893'}
  ]
};

var productHandles={
  thyroid:'thyroid-support',
  insulin:'blood-sugar-support',
  b12:'vitamin-b12',
  cortisol:'cortisol-control-formula',
  leakygut:'probiotic-complex-120-caps',
  estrogen:'hormonal-support-formula',
  vitamind:'liquid-vitamin-d'
};

var energyQs={thyroid:[0,1,4],insulin:[3,6],b12:[2],cortisol:[1,12],vitamind:[2]};

/* ─── Helpers ─── */
function $(id){return document.getElementById(id);}
function bindClick(id,fn){var el=$(id);if(el)el.addEventListener('click',fn);}
function scrollTop(){var el=$('ha3-wrap');if(el)el.scrollIntoView({behavior:'smooth',block:'start'});}

/* ─── Scoring ─── */
function checkTriggers(id,ans){
  var h=function(i){return ans.has(i);};
  if(id==='thyroid'){
    if(h(0)&&(h(5)||h(12)||h(3)))return'red';
    if(h(0)&&(h(1)||h(4)))return'red';
    return null;
  }
  if(id==='insulin'){
    if(h(0)||h(2)||h(7)||h(11)||h(12))return'red';
    return null;
  }
  if(id==='b12'){
    if(h(2)&&(h(10)||h(9)||h(12)||h(0)))return'red';
    if(h(10)||h(12))return'amber';
    return null;
  }
  if(id==='cortisol'){
    if(h(1))return'red';
    if(h(12)&&h(0))return'red';
    if(h(3))return'red';
    if(h(12))return'amber';
    return null;
  }
  if(id==='leakygut'){
    if(h(0)||h(1)||h(3)||h(6)||h(9)||h(11))return'red';
    return null;
  }
  if(id==='estrogen'){
    var strongIdxs=[1,3,4,7,10,14,20],count=0;
    for(var i=0;i<strongIdxs.length;i++)if(h(strongIdxs[i]))count++;
    if(count>=2)return'red';
    if(count===1)return'amber';
    return null;
  }
  if(id==='vitamind'){
    if(h(7))return'red';
    if(!h(10)||!h(9))return'red';
    return null;
  }
  return null;
}

function calcScore(sec){
  var total=0,max=0;
  for(var i=0;i<sec.weights.length;i++)if(sec.weights[i]>0)max+=sec.weights[i];
  for(var i=0;i<sec.qs.length;i++)if(answers[sec.id].has(i))total+=sec.weights[i];
  if(max===0)return 0;
  return Math.max(0,Math.round((total/max)*100));
}

function getFinalColor(sec){
  var t=checkTriggers(sec.id,answers[sec.id]);
  if(t)return t;
  var p=calcScore(sec);
  return p>=50?'red':p>=25?'amber':'green';
}

function getRiskLabel(col){
  if(col==='red')return{emoji:'\u26A0\uFE0F',label:'High risk'};
  if(col==='amber')return{emoji:'\uD83D\uDC40',label:'Moderate risk'};
  return{emoji:'\u2705',label:'Looking good'};
}

function checkEnergy(){
  var count=0;
  for(var i=0;i<sections.length;i++){
    var eqs=energyQs[sections[i].id];if(!eqs)continue;
    for(var j=0;j<eqs.length;j++)if(answers[sections[i].id].has(eqs[j]))count++;
  }
  return count>=2;
}

/* ─── Sections ─── */
function buildSections(){
  sections=base.slice();
  if(gender==='female')sections.push(estrogenSec);
  answers={};
  for(var i=0;i<sections.length;i++)answers[sections[i].id]=new Set();
}

/* ─── localStorage resume ─── */
function saveProgress(){
  try{
    var data={gender:gender,step:step,answers:{}};
    for(var key in answers){
      if(answers.hasOwnProperty(key))data.answers[key]=Array.from(answers[key]);
    }
    localStorage.setItem(STORAGE_KEY,JSON.stringify(data));
  }catch(e){}
}

function loadProgress(){
  try{
    var raw=localStorage.getItem(STORAGE_KEY);
    if(!raw)return null;
    return JSON.parse(raw);
  }catch(e){return null;}
}

function clearProgress(){
  try{localStorage.removeItem(STORAGE_KEY);}catch(e){}
}

function restoreProgress(data){
  gender=data.gender;
  buildSections();
  step=data.step||0;
  for(var key in data.answers){
    if(data.answers.hasOwnProperty(key)&&answers.hasOwnProperty(key)){
      answers[key]=new Set(data.answers[key]);
    }
  }
}

/* ─── Sticky bottom nav ─── */
function updateStickyBot(visible,backVisible,countText,nextText,onBack,onNext){
  var bot=$('ha3-sticky-bot');
  if(!bot)return;
  bot.style.display=visible?'':'none';
  var backBtn=$('ha3-bot-back');
  var countEl=$('ha3-bot-count');
  var nextBtn=$('ha3-bot-next');
  if(backBtn){
    backBtn.style.display=backVisible?'':'none';
    backBtn.onclick=onBack||null;
  }
  if(countEl)countEl.textContent=countText||'';
  if(nextBtn){
    nextBtn.textContent=nextText||'Next \u2192';
    nextBtn.onclick=onNext||null;
  }
}

function updateStickyTop(label){
  var top=$('ha3-sticky-top');
  var labelEl=$('ha3-step-label');
  if(top)top.style.display='';
  if(labelEl)labelEl.textContent=label||'';
}

/* ─── Video modal ─── */
function openVideoModal(videoId){
  var modal=$('ha3-vid-modal');
  var player=$('ha3-vid-player');
  if(!modal||!player)return;
  player.innerHTML='<iframe src="https://www.youtube.com/embed/'+videoId+'?autoplay=1&rel=0" allow="autoplay; encrypted-media" allowfullscreen></iframe>';
  modal.style.display='flex';
  document.body.style.overflow='hidden';
}

function closeVideoModal(){
  var modal=$('ha3-vid-modal');
  var player=$('ha3-vid-player');
  if(!modal)return;
  modal.style.display='none';
  if(player)player.innerHTML='';
  document.body.style.overflow='';
}

/* ─── Podcast Player (mini bar + now-playing overlay, same as podcast hub) ─── */
var podAudio=null,podMiniEl=null,podOverlayEl=null,podBuilt=false,podClosing=false;
var podSpeedOptions=[1,1.25,1.5,2],podSpeedIdx=0;

var POD_ICON_PLAY='<svg viewBox="0 0 24 24" fill="currentColor"><polygon points="6,3 20,12 6,21"/></svg>';
var POD_ICON_PAUSE='<svg viewBox="0 0 24 24" fill="currentColor"><rect x="5" y="3" width="4" height="18" rx="1"/><rect x="15" y="3" width="4" height="18" rx="1"/></svg>';
var POD_ICON_SKIP_FWD='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M23 4v6h-6"/><path d="M20.49 15a9 9 0 1 1-2.12-9.36L23 10"/><text x="12" y="16" text-anchor="middle" fill="currentColor" stroke="none" font-size="7" font-weight="700">15</text></svg>';
var POD_ICON_SKIP_BACK='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M1 4v6h6"/><path d="M3.51 15a9 9 0 1 0 2.12-9.36L1 10"/><text x="12" y="16" text-anchor="middle" fill="currentColor" stroke="none" font-size="7" font-weight="700">15</text></svg>';
var POD_ICON_CLOSE='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>';
var POD_ICON_SPEED='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>';
var POD_ICON_MIC='<svg viewBox="0 0 24 24" fill="#a45ea5"><path d="M12 1a3 3 0 0 0-3 3v8a3 3 0 0 0 6 0V4a3 3 0 0 0-3-3zm-1 18.93A7.004 7.004 0 0 1 5 13h2a5 5 0 0 0 10 0h2a7.004 7.004 0 0 1-6 6.93V22h4v2H7v-2h4v-2.07z"/></svg>';

function podFormatTime(sec){
  if(!sec||isNaN(sec)||!isFinite(sec))return'0:00';
  sec=Math.floor(sec);
  var h=Math.floor(sec/3600),m=Math.floor((sec%3600)/60),s=sec%60;
  if(h>0)return h+':'+(m<10?'0':'')+m+':'+(s<10?'0':'')+s;
  return m+':'+(s<10?'0':'')+s;
}

function buildPodPlayer(){
  if(podBuilt)return;
  podBuilt=true;

  try{
    var saved=parseFloat(localStorage.getItem('ha3-pod-speed'));
    if(saved&&podSpeedOptions.indexOf(saved)!==-1)podSpeedIdx=podSpeedOptions.indexOf(saved);
  }catch(e){}

  podAudio=new Audio();
  podAudio.preload='auto';
  podAudio.playbackRate=podSpeedOptions[podSpeedIdx];

  /* Mini Bar */
  podMiniEl=document.createElement('div');
  podMiniEl.className='ha3__pmini';
  podMiniEl.id='ha3-pmini';
  podMiniEl.setAttribute('role','region');
  podMiniEl.setAttribute('aria-label','Podcast player');
  podMiniEl.innerHTML=
    '<div class="ha3__pmini__progress"><div class="ha3__pmini__progress-fill" id="ha3-pmini-prog"></div></div>'+
    '<div class="ha3__pmini__inner">'+
      '<div class="ha3__pmini__info" id="ha3-pmini-info">'+
        '<div class="ha3__pmini__icon">'+POD_ICON_MIC+'</div>'+
        '<p class="ha3__pmini__title" id="ha3-pmini-title">\u2014</p>'+
      '</div>'+
      '<div class="ha3__pmini__controls">'+
        '<button class="ha3__pmini__play" id="ha3-pmini-play" aria-label="Play or pause"><span class="ha3__pmini__play-icon">'+POD_ICON_PLAY+'</span></button>'+
        '<button class="ha3__pmini__close" id="ha3-pmini-close" aria-label="Close player">'+POD_ICON_CLOSE+'</button>'+
      '</div>'+
    '</div>';
  document.body.appendChild(podMiniEl);

  /* Now Playing Overlay */
  podOverlayEl=document.createElement('div');
  podOverlayEl.className='ha3__pnp';
  podOverlayEl.id='ha3-pnp';
  podOverlayEl.setAttribute('role','dialog');
  podOverlayEl.setAttribute('aria-label','Now Playing');
  podOverlayEl.innerHTML=
    '<div class="ha3__pnp__scrim" id="ha3-pnp-scrim"></div>'+
    '<div class="ha3__pnp__panel">'+
      '<button class="ha3__pnp__collapse" id="ha3-pnp-collapse" aria-label="Collapse player"><span class="ha3__pnp__handle-bar"></span></button>'+
      '<div class="ha3__pnp__header">'+
        '<span class="ha3__pnp__header-label">Now Playing</span>'+
        '<button class="ha3__pnp__close" id="ha3-pnp-close" aria-label="Close player">'+POD_ICON_CLOSE+'</button>'+
      '</div>'+
      '<div class="ha3__pnp__artwork-wrap">'+
        '<div class="ha3__pnp__artwork"><svg viewBox="0 0 24 24" fill="#a45ea5"><path d="M12 1a3 3 0 0 0-3 3v8a3 3 0 0 0 6 0V4a3 3 0 0 0-3-3zm-1 18.93A7.004 7.004 0 0 1 5 13h2a5 5 0 0 0 10 0h2a7.004 7.004 0 0 1-6 6.93V22h4v2H7v-2h4v-2.07z"/></svg></div>'+
      '</div>'+
      '<div class="ha3__pnp__titles">'+
        '<h2 class="ha3__pnp__title" id="ha3-pnp-title">\u2014</h2>'+
        '<p class="ha3__pnp__subtitle" id="ha3-pnp-subtitle">Dr. Martin</p>'+
      '</div>'+
      '<div class="ha3__pnp__progress-area">'+
        '<input type="range" class="ha3__pnp__range" id="ha3-pnp-range" min="0" max="1000" value="0">'+
        '<div class="ha3__pnp__times">'+
          '<span class="ha3__pnp__time" id="ha3-pnp-cur">0:00</span>'+
          '<span class="ha3__pnp__time" id="ha3-pnp-dur">0:00</span>'+
        '</div>'+
      '</div>'+
      '<div class="ha3__pnp__controls">'+
        '<button class="ha3__pnp__skip" id="ha3-pnp-back" aria-label="Rewind 15 seconds">'+POD_ICON_SKIP_BACK+'</button>'+
        '<button class="ha3__pnp__play-btn" id="ha3-pnp-play" aria-label="Play or pause"><span class="ha3__pnp__play-icon">'+POD_ICON_PLAY+'</span></button>'+
        '<button class="ha3__pnp__skip" id="ha3-pnp-fwd" aria-label="Forward 15 seconds">'+POD_ICON_SKIP_FWD+'</button>'+
      '</div>'+
      '<div class="ha3__pnp__secondary">'+
        '<button class="ha3__pnp__sec-btn" id="ha3-pnp-speed" aria-label="Playback speed">'+
          '<span class="ha3__pnp__sec-icon">'+POD_ICON_SPEED+'</span>'+
          '<span class="ha3__pnp__sec-label" id="ha3-pnp-speed-label">'+podSpeedOptions[podSpeedIdx]+'x</span>'+
        '</button>'+
      '</div>'+
    '</div>';
  document.body.appendChild(podOverlayEl);

  bindPodEvents();
}

function bindPodEvents(){
  var miniPlay=$('ha3-pmini-play');
  var miniClose=$('ha3-pmini-close');
  var miniInfo=$('ha3-pmini-info');
  var npPlay=$('ha3-pnp-play');
  var npBack=$('ha3-pnp-back');
  var npFwd=$('ha3-pnp-fwd');
  var npCollapse=$('ha3-pnp-collapse');
  var npCloseX=$('ha3-pnp-close');
  var npScrim=$('ha3-pnp-scrim');
  var npSpeed=$('ha3-pnp-speed');
  var npRange=$('ha3-pnp-range');
  var miniProg=$('ha3-pmini-prog');
  var timeCur=$('ha3-pnp-cur');
  var timeDur=$('ha3-pnp-dur');
  var isSeeking=false;

  function togglePlay(){
    if(!podAudio.src)return;
    if(podAudio.paused)podAudio.play();else podAudio.pause();
  }
  function updatePlayIcons(playing){
    var icon=playing?POD_ICON_PAUSE:POD_ICON_PLAY;
    var mi=podMiniEl.querySelector('.ha3__pmini__play-icon');
    var ni=podOverlayEl.querySelector('.ha3__pnp__play-icon');
    if(mi)mi.innerHTML=icon;
    if(ni)ni.innerHTML=icon;
    if(playing)podOverlayEl.classList.add('ha3__pnp--playing');
    else podOverlayEl.classList.remove('ha3__pnp--playing');
  }

  miniPlay.addEventListener('click',function(e){e.stopPropagation();togglePlay();});
  npPlay.addEventListener('click',togglePlay);
  podAudio.addEventListener('play',function(){updatePlayIcons(true);});
  podAudio.addEventListener('pause',function(){updatePlayIcons(false);});

  npBack.addEventListener('click',function(){podAudio.currentTime=Math.max(0,podAudio.currentTime-15);});
  npFwd.addEventListener('click',function(){podAudio.currentTime=Math.min(podAudio.duration||0,podAudio.currentTime+15);});

  podAudio.addEventListener('timeupdate',function(){
    if(!podAudio.duration||isSeeking)return;
    var pct=(podAudio.currentTime/podAudio.duration)*1000;
    npRange.value=pct;
    if(miniProg)miniProg.style.width=(pct/10)+'%';
    timeCur.textContent=podFormatTime(podAudio.currentTime);
    timeDur.textContent=podFormatTime(podAudio.duration);
  });

  npRange.addEventListener('input',function(){
    isSeeking=true;
    if(podAudio.duration)timeCur.textContent=podFormatTime((npRange.value/1000)*podAudio.duration);
  });
  npRange.addEventListener('change',function(){
    if(podAudio.duration)podAudio.currentTime=(npRange.value/1000)*podAudio.duration;
    isSeeking=false;
  });

  function openOverlay(){
    if(podClosing)return;
    podOverlayEl.classList.add('ha3__pnp--visible');
    document.body.style.overflow='hidden';
  }
  function minimizeOverlay(){
    podOverlayEl.classList.remove('ha3__pnp--visible');
    document.body.style.overflow='';
  }
  function closePlayer(){
    podClosing=true;
    podOverlayEl.classList.add('ha3__pnp--closing');
    podMiniEl.classList.add('ha3__pmini--closing');
    podOverlayEl.classList.remove('ha3__pnp--visible','ha3__pnp--playing');
    podMiniEl.classList.remove('ha3__pmini--visible');
    document.body.style.overflow='';
    podAudio.pause();
    podAudio.src='';
    updatePlayIcons(false);
    setTimeout(function(){
      podOverlayEl.classList.remove('ha3__pnp--closing');
      podMiniEl.classList.remove('ha3__pmini--closing');
      podClosing=false;
    },50);
  }

  miniInfo.addEventListener('click',function(e){e.stopPropagation();openOverlay();});
  podMiniEl.addEventListener('click',function(e){
    if(e.target.closest('.ha3__pmini__play')||e.target.closest('.ha3__pmini__close'))return;
    openOverlay();
  });

  npCollapse.addEventListener('click',function(e){e.preventDefault();e.stopPropagation();minimizeOverlay();});
  npScrim.addEventListener('click',function(e){e.preventDefault();e.stopPropagation();minimizeOverlay();});

  miniClose.addEventListener('mousedown',function(e){e.preventDefault();e.stopPropagation();e.stopImmediatePropagation();closePlayer();},true);
  miniClose.addEventListener('click',function(e){e.preventDefault();e.stopPropagation();e.stopImmediatePropagation();},true);
  npCloseX.addEventListener('mousedown',function(e){e.preventDefault();e.stopPropagation();e.stopImmediatePropagation();closePlayer();},true);
  npCloseX.addEventListener('click',function(e){e.preventDefault();e.stopPropagation();e.stopImmediatePropagation();},true);
  miniClose.addEventListener('touchend',function(e){e.preventDefault();e.stopPropagation();closePlayer();},{passive:false});
  npCloseX.addEventListener('touchend',function(e){e.preventDefault();e.stopPropagation();closePlayer();},{passive:false});

  npSpeed.addEventListener('click',function(){
    podSpeedIdx=(podSpeedIdx+1)%podSpeedOptions.length;
    var spd=podSpeedOptions[podSpeedIdx];
    podAudio.playbackRate=spd;
    $('ha3-pnp-speed-label').textContent=spd+'x';
    try{localStorage.setItem('ha3-pod-speed',spd);}catch(e){}
  });

  podAudio.addEventListener('ended',function(){updatePlayIcons(false);});
}

function playPodcast(audioUrl,title,meta){
  buildPodPlayer();
  podAudio.pause();
  $('ha3-pmini-title').textContent=title;
  $('ha3-pnp-title').textContent=title;
  $('ha3-pnp-subtitle').textContent=meta||'Dr. Martin';
  $('ha3-pnp-range').value=0;
  $('ha3-pmini-prog').style.width='0%';
  $('ha3-pnp-cur').textContent='0:00';
  $('ha3-pnp-dur').textContent='0:00';
  podAudio.src=audioUrl;
  podAudio.playbackRate=podSpeedOptions[podSpeedIdx];
  podAudio.play().catch(function(){});
  podMiniEl.classList.add('ha3__pmini--visible');
  podOverlayEl.classList.add('ha3__pnp--visible');
  document.body.style.overflow='hidden';
}

/* ─── Render: Gender ─── */
function renderGender(){
  setProgress3(5);
  var total=base.length+(gender==='female'?1:0)+2;
  updateStickyTop('Step 1 of '+total+' \u2014 Getting started');
  $('ha3-screen').innerHTML=
    '<div class="ha3__sec-label">Step 1 of '+total+'</div>'+
    '<div class="ha3__sec-title">Let\'s find out what your body needs</div>'+
    '<div class="ha3__sec-sub" style="margin-bottom:1.25rem">Some questions are tailored to you. Which best describes you?</div>'+
    '<div class="ha3__gbtn-wrap">'+
      '<button id="btn-female" class="ha3__gbtn'+(gender==='female'?' sel':'')+'">Female</button>'+
      '<button id="btn-male" class="ha3__gbtn'+(gender==='male'?' sel':'')+'">Male</button>'+
    '</div>'+
    '<div class="ha3__nav-row"><span></span><span class="ha3__hint-txt">Required to continue</span>'+
    '<button id="btn-next-gender" class="ha3__btn ha3__btn-pri'+(gender?'':' dimmed')+'">Next &#8594;</button></div>';

  bindClick('btn-female',function(){gender='female';renderGender();});
  bindClick('btn-male',function(){gender='male';renderGender();});
  bindClick('btn-next-gender',function(){if(!gender)return;buildSections();step=0;render();});

  updateStickyBot(true,false,'','Next \u2192',null,function(){if(!gender)return;buildSections();step=0;render();});
}

/* ─── Render: Question Step ─── */
function render(){
  if(step>=sections.length){renderCapture();return;}
  var sec=sections[step];
  var stepNum=step+2,totalNum=sections.length+2;
  var pct=Math.round((stepNum/(totalNum+1))*100);
  setProgress3(pct);
  updateStickyTop('Step '+stepNum+' of '+totalNum+' \u2014 '+sec.name);

  var selCount=answers[sec.id].size;
  var html='<div class="ha3__sec-label">Step '+stepNum+' of '+totalNum+'</div>'+
    '<div class="ha3__sec-title">'+sec.name+' health check</div>'+
    '<div class="ha3__sec-sub">'+sec.sub+'</div>'+
    '<div class="ha3__sel-count">'+(selCount>0?selCount+' selected':'')+'</div>';

  for(var i=0;i<sec.qs.length;i++){
    var sel=answers[sec.id].has(i)?' sel':'';
    html+='<div class="ha3__q-item'+sel+'" data-sec="'+sec.id+'" data-idx="'+i+'">'+
      '<span class="ha3__q-txt">'+sec.qs[i]+'</span>'+
      '<span class="ha3__chk"><svg class="ha3__chk-svg" viewBox="0 0 12 12" fill="none"><path d="M2 6l3 3 5-5" stroke="#fff" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg></span>'+
    '</div>';
  }

  var nextLabel=step<sections.length-1?'Next &#8594;':'See my results &#8594;';
  html+='<div class="ha3__nav-row"><button id="btn-back" class="ha3__btn">&#8592; Back</button><span class="ha3__hint-txt">Check all that apply</span>'+
    '<button id="btn-next" class="ha3__btn ha3__btn-pri">'+nextLabel+'</button></div>';

  $('ha3-screen').innerHTML=html;

  var qs=document.querySelectorAll('#ha3-screen .ha3__q-item');
  for(var j=0;j<qs.length;j++){
    qs[j].addEventListener('click',(function(el){return function(){
      var sid=el.getAttribute('data-sec'),idx=parseInt(el.getAttribute('data-idx'));
      if(answers[sid].has(idx))answers[sid].delete(idx);else answers[sid].add(idx);
      saveProgress();
      render();
    };})(qs[j]));
  }

  bindClick('btn-back',function(){if(step===0){renderGender();return;}step--;saveProgress();render();scrollTop();});
  bindClick('btn-next',function(){step++;saveProgress();render();scrollTop();});

  var mobileNextLabel=step<sections.length-1?'Next \u2192':'See results';
  updateStickyBot(true,true,selCount>0?selCount+' selected':'',mobileNextLabel,
    function(){if(step===0){renderGender();return;}step--;saveProgress();render();scrollTop();},
    function(){step++;saveProgress();render();scrollTop();}
  );
}

/* ─── Render: Email Capture ─── */
function renderCapture(){
  setProgress3(95);
  updateStickyTop('Almost done');

  $('ha3-screen').innerHTML=
    '<div class="ha3__sec-label">Almost done</div>'+
    '<div class="ha3__sec-title">Where should we send your results?</div>'+
    '<div class="ha3__sec-sub">Enter your details below to see your personalized health assessment.</div>'+
    '<div class="ha3__capture-card">'+
      '<div class="ha3__field-wrap">'+
        '<label class="ha3__field-label" for="cap-fname">First name</label>'+
        '<input class="ha3__field-input" type="text" id="cap-fname" placeholder="Your first name" autocomplete="given-name">'+
      '</div>'+
      '<div class="ha3__field-wrap">'+
        '<label class="ha3__field-label" for="cap-email">Email address</label>'+
        '<input class="ha3__field-input" type="email" id="cap-email" placeholder="you@example.com" autocomplete="email">'+
        '<div class="ha3__error-msg" id="cap-error">Please enter a valid email address.</div>'+
      '</div>'+
    '</div>'+
    '<div class="ha3__nav-row">'+
      '<button id="btn-cap-back" class="ha3__btn">&#8592; Back</button>'+
      '<button class="ha3__skip-link" id="btn-skip">Skip &#8594;</button>'+
      '<button id="btn-cap-submit" class="ha3__btn ha3__btn-pri">See my results &#8594;</button>'+
    '</div>';

  bindClick('btn-cap-back',function(){step--;saveProgress();render();scrollTop();});
  bindClick('btn-skip',function(){computeResults();clearProgress();showResults();});
  bindClick('btn-cap-submit',function(){
    var fname=document.getElementById('cap-fname').value.trim();
    var email=document.getElementById('cap-email').value.trim();
    var errEl=document.getElementById('cap-error');
    if(!email||!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)){
      errEl.style.display='block';
      return;
    }
    errEl.style.display='none';
    computeResults();
    sendToKlaviyo(fname,email,quizResults);
    clearProgress();
    showResults();
  });

  updateStickyBot(true,true,'','See results',
    function(){step--;saveProgress();render();scrollTop();},
    function(){
      var email=document.getElementById('cap-email');
      if(email)email.closest('form')||document.getElementById('btn-cap-submit').click();
    }
  );
}

function computeResults(){
  quizResults={};
  for(var i=0;i<sections.length;i++){
    var col=getFinalColor(sections[i]);
    var label=getRiskLabel(col).label;
    quizResults[sections[i].name]=label;
  }
}

function sendToKlaviyo(fname,email,results){
  var genderLabel=gender==='female'?'Female':'Male';
  var now=new Date().toISOString();

  /* Legacy Quiz_* props (backward compat) + new hha_* namespaced props */
  var props={
    Quiz_Gender:genderLabel,
    hha_gender:genderLabel,
    hha_quiz_version:'v3',
    hha_completed_at:now
  };
  var eventProps={
    quiz_version:'v3',
    gender:genderLabel
  };
  var highCount=0,modCount=0,topPriority='none';
  var nsMap={Thyroid:'thyroid',Insulin:'insulin',B12:'b12',Cortisol:'cortisol','Leaky Gut':'leaky_gut','Vitamin D':'vitamin_d',Estrogen:'estrogen'};

  for(var key in results){
    if(results.hasOwnProperty(key)){
      var val=results[key];
      props['Quiz_'+key.replace(/\s+/g,'_')]=val;
      var ns=nsMap[key]||key.toLowerCase().replace(/\s+/g,'_');
      props['hha_'+ns+'_risk']=val;
      eventProps[ns+'_risk']=val;
      if(val==='High risk'){highCount++;if(topPriority==='none')topPriority=key;}
      else if(val==='Moderate risk'){modCount++;}
    }
  }
  eventProps.high_risk_count=highCount;
  eventProps.moderate_risk_count=modCount;
  eventProps.top_priority=topPriority;

  if(DEBUG_KLAVIYO)console.log('[Klaviyo Debug] Profile props:',JSON.parse(JSON.stringify(props)));
  if(DEBUG_KLAVIYO)console.log('[Klaviyo Debug] Event props:',JSON.parse(JSON.stringify(eventProps)));

  /* Fetch 1: Subscription + profile properties */
  var subPayload={
    data:{
      type:'subscription',
      attributes:{
        custom_source:'Health Assessment Quiz v3',
        profile:{
          data:{
            type:'profile',
            attributes:{
              email:email,
              first_name:fname||undefined,
              properties:props
            }
          }
        }
      },
      relationships:{
        list:{data:{type:'list',id:KLAVIYO_LIST_ID}}
      }
    }
  };
  fetch('https://a.klaviyo.com/client/subscriptions/?company_id='+KLAVIYO_PUBLIC_KEY,{
    method:'POST',
    headers:{'Content-Type':'application/json','revision':'2023-12-15'},
    body:JSON.stringify(subPayload)
  }).then(function(r){if(DEBUG_KLAVIYO)console.log('[Klaviyo Debug] Subscription response:',r.status);})
    .catch(function(e){if(DEBUG_KLAVIYO)console.error('[Klaviyo Debug] Subscription error:',e);});

  /* Fetch 2: Event for history tracking */
  var eventPayload={
    data:{
      type:'event',
      attributes:{
        metric:{data:{type:'metric',attributes:{name:'Health Assessment Completed'}}},
        profile:{data:{type:'profile',attributes:{email:email}}},
        properties:eventProps,
        time:now
      }
    }
  };
  fetch('https://a.klaviyo.com/client/events/?company_id='+KLAVIYO_PUBLIC_KEY,{
    method:'POST',
    headers:{'Content-Type':'application/json','revision':'2023-12-15'},
    body:JSON.stringify(eventPayload)
  }).then(function(r){if(DEBUG_KLAVIYO)console.log('[Klaviyo Debug] Event response:',r.status);})
    .catch(function(e){if(DEBUG_KLAVIYO)console.error('[Klaviyo Debug] Event error:',e);});
}

/* ─── Render: Results ─── */
function showResults(){
  setProgress3(100);
  var top=$('ha3-sticky-top');
  if(top)top.style.display='none';
  updateStickyBot(false);

  var scores=[];
  for(var i=0;i<sections.length;i++){
    var col=getFinalColor(sections[i]);
    scores.push({id:sections[i].id,name:sections[i].name,col:col});
  }
  scores.sort(function(a,b){
    var order={red:0,amber:1,green:2};
    return order[a.col]-order[b.col];
  });

  var redS=scores.filter(function(s){return s.col==='red';});
  var ambS=scores.filter(function(s){return s.col==='amber';});
  var showNav=checkEnergy();

  /* Score cards */
  var cardsHtml='';
  for(var i=0;i<scores.length;i++){
    var s=scores[i],isTop=i===0;
    var risk=getRiskLabel(s.col);
    cardsHtml+='<div class="ha3__sc '+s.col+(isTop?' top-card':'')+'">'+
      (isTop?'<div class="ha3__top-badge">Top priority</div>':'')+
      '<div class="ha3__sc-name">'+s.name+'</div>'+
      '<div class="ha3__sc-emoji">'+risk.emoji+'</div>'+
      '<div class="ha3__sc-risk">'+risk.label+'</div>'+
    '</div>';
  }

  /* Product recommendations (collapsible) */
  var recsHtml='';
  if(redS.length>0){
    recsHtml+='<div class="ha3__rec-heading">Priority support &#8212; address these first</div>';
    for(var i=0;i<redS.length;i++){
      var p=products[redS[i].id];if(!p)continue;
      recsHtml+=buildProductCard(redS[i],'priority','High risk');
    }
  }
  if(ambS.length>0){
    recsHtml+='<div class="ha3__rec-heading">Worth addressing &#8212; don\'t ignore these</div>';
    for(var i=0;i<ambS.length;i++){
      var p=products[ambS[i].id];if(!p)continue;
      recsHtml+=buildProductCard(ambS[i],'watching','Moderate risk');
    }
  }
  if(showNav){
    var nav=products.navitol;
    recsHtml+='<div class="ha3__pcard navitol">'+
      '<div class="ha3__p-eye">Also recommended &#8212; energy support</div>'+
      '<div class="ha3__p-name">'+nav.name+'</div>'+
      '<button class="ha3__p-toggle">Learn why <span class="ha3__p-toggle-chevron">&#9660;</span></button>'+
      '<div class="ha3__p-detail">'+
        '<div class="ha3__p-teach">'+nav.teach+'</div>'+
        '<div class="ha3__p-why-label">Why it helps</div>'+
        '<div class="ha3__p-why">'+nav.why+'</div>'+
      '</div>'+
    '</div>';
  }
  if(redS.length===0&&ambS.length===0&&!showNav){
    recsHtml='<p class="ha3__all-clear">Your scores are looking healthy across the board. Consider Navitol Ultra Strength as a daily foundation for energy, circulation, and immune health.</p>';
  }

  /* Video/podcast recommendations — only for high risk (red) sections */
  var vidHtml=redS.length>0?buildVideoSection(redS):'';

  /* Buy boxes — only for red (priority) sections */
  var buyHtml=buildBuyBoxes(redS);

  $('ha3-screen').innerHTML=
    '<div class="ha3__res-title">Your results</div>'+
    '<div class="ha3__res-sub">Here\'s how each area scored. Red means your body is asking for help. Yellow means it\'s worth paying attention to.</div>'+
    '<div class="ha3__legend">'+
      '<span class="ha3__leg-item"><span class="ha3__leg-emoji">&#x2705;</span> Looking good</span>'+
      '<span class="ha3__leg-item"><span class="ha3__leg-emoji">&#x1F440;</span> Moderate risk</span>'+
      '<span class="ha3__leg-item"><span class="ha3__leg-emoji">&#x26A0;&#xFE0F;</span> High risk</span>'+
    '</div>'+
    '<div class="ha3__card-grid">'+cardsHtml+'</div>'+
    '<div class="ha3__divider"></div>'+
    recsHtml+
    '<div class="ha3__divider"></div>'+
    vidHtml+
    '<div class="ha3__trust-block">'+
      '<div class="ha3__trust-stars">'+
        '<svg width="28" height="28" viewBox="0 0 24 24" fill="#f5a623"><path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/></svg>'+
        '<svg width="28" height="28" viewBox="0 0 24 24" fill="#f5a623"><path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/></svg>'+
        '<svg width="28" height="28" viewBox="0 0 24 24" fill="#f5a623"><path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/></svg>'+
        '<svg width="28" height="28" viewBox="0 0 24 24" fill="#f5a623"><path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/></svg>'+
        '<svg width="28" height="28" viewBox="0 0 24 24" fill="#f5a623"><path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/></svg>'+
      '</div>'+
      '<p class="ha3__trust-customers">Trusted by <strong>142,256+</strong> Customers</p>'+
      '<p class="ha3__trust-tagline">The Wisdom of 100,000+ Patient Visits<br>in Every Capsule.</p>'+
      '<p class="ha3__trust-sub"><em>Proven in Practice. Trusted by Patients. Made for You.</em></p>'+
      '<a href="/pages/shop-all" class="ha3__trust-cta">Shop Dr. Martin\u2019s Formulas &#8594;</a>'+
      '<div class="ha3__trust-badges">'+
        '<span class="ha3__trust-badge"><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/></svg> 60-Day Guarantee</span>'+
        '<span class="ha3__trust-badge"><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/><polyline points="22 4 12 14.01 9 11.01"/></svg> Doctor-Formulated</span>'+
        '<span class="ha3__trust-badge"><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M12 2L2 7l10 5 10-5-10-5z"/><path d="M2 17l10 5 10-5"/><path d="M2 12l10 5 10-5"/></svg> Clinically Informed</span>'+
      '</div>'+
    '</div>'+
    '<div style="margin-top:1.25rem"><button id="btn-restart" class="ha3__btn">Start over</button></div>';

  /* Wire up collapsible cards */
  var toggles=document.querySelectorAll('.ha3__p-toggle');
  for(var t=0;t<toggles.length;t++){
    toggles[t].addEventListener('click',function(){
      this.closest('.ha3__pcard').classList.toggle('open');
    });
  }

  /* Wire up video cards */
  var vidCards=document.querySelectorAll('.ha3__vid-card');
  for(var v=0;v<vidCards.length;v++){
    vidCards[v].addEventListener('click',function(){
      var vid=this.getAttribute('data-video-id');
      if(vid)openVideoModal(vid);
    });
  }

  /* Wire up podcast cards */
  var podCards=document.querySelectorAll('.ha3__pod-card');
  for(var p=0;p<podCards.length;p++){
    podCards[p].addEventListener('click',function(){
      var audioUrl=this.getAttribute('data-pod-audio');
      var title=this.getAttribute('data-pod-title');
      var meta=this.getAttribute('data-pod-meta');
      if(audioUrl)playPodcast(audioUrl,title,meta);
    });
  }

  bindClick('btn-restart',function(){
    gender=null;step=0;sections=[];answers={};quizResults={};
    clearProgress();
    renderGender();
    scrollTop();
  });

  scrollTop();
}

function buildProductCard(scoreObj,cardClass,riskLabel){
  var p=products[scoreObj.id];
  if(!p)return'';
  var openClass=cardClass==='priority'?' open':'';
  return '<div class="ha3__pcard '+cardClass+openClass+'">'+
    '<div class="ha3__p-eye">'+riskLabel+' &#8212; '+scoreObj.name+'</div>'+
    '<div class="ha3__p-name">'+p.name+'</div>'+
    '<button class="ha3__p-toggle">Learn why <span class="ha3__p-toggle-chevron">&#9660;</span></button>'+
    '<div class="ha3__p-detail">'+
      '<div class="ha3__p-teach">'+p.teach+'</div>'+
      '<div class="ha3__p-why-label">Why it helps</div>'+
      '<div class="ha3__p-why">'+p.why+'</div>'+
    '</div>'+
  '</div>';
}

function buildVideoSection(scores){
  var html='<div class="ha3__vid-section">'+
    '<div class="ha3__vid-heading">Learn more from Dr. Martin</div>'+
    '<div class="ha3__vid-sub">Watch or listen to Dr. Martin explain what\'s happening in your body and what you can do about it.</div>';

  for(var i=0;i<scores.length;i++){
    var s=scores[i];
    var items=contentBySection[s.id];
    if(!items||items.length===0)continue;

    html+='<div class="ha3__vid-topic">'+s.name+'</div>';
    html+='<div class="ha3__vid-row">';
    for(var j=0;j<items.length;j++){
      var item=items[j];
      if(item.type==='video'){
        html+='<div class="ha3__vid-card" data-video-id="'+item.id+'">'+
          '<div class="ha3__vid-thumb-wrap">'+
            '<img class="ha3__vid-thumb" src="https://img.youtube.com/vi/'+item.id+'/mqdefault.jpg" alt="'+item.title+'" loading="lazy">'+
            '<div class="ha3__vid-play"><svg viewBox="0 0 24 24" fill="white"><polygon points="8,5 19,12 8,19"/></svg></div>'+
          '</div>'+
          '<div class="ha3__vid-info">'+
            '<div class="ha3__vid-badge ha3__vid-badge--video">Video</div>'+
            '<div class="ha3__vid-title">'+item.title+'</div>'+
            '<div class="ha3__vid-meta">'+item.meta+'</div>'+
          '</div>'+
        '</div>';
      } else if(item.type==='podcast'){
        html+='<div class="ha3__pod-card" data-pod-audio="'+item.audio+'" data-pod-title="'+item.title+'" data-pod-meta="'+item.meta+'">'+
          '<div class="ha3__pod-icon"><svg viewBox="0 0 24 24" width="28" height="28" fill="#92278f"><path d="M12 1a3 3 0 0 0-3 3v8a3 3 0 0 0 6 0V4a3 3 0 0 0-3-3zm-1 18.93A7.004 7.004 0 0 1 5 13h2a5 5 0 0 0 10 0h2a7.004 7.004 0 0 1-6 6.93V22h4v2H7v-2h4v-2.07z"/></svg></div>'+
          '<div class="ha3__pod-info">'+
            '<div class="ha3__vid-badge ha3__vid-badge--podcast">Podcast</div>'+
            '<div class="ha3__pod-title">'+item.title+'</div>'+
            '<div class="ha3__vid-meta">'+item.meta+'</div>'+
          '</div>'+
          '<div class="ha3__pod-play-btn"><svg viewBox="0 0 24 24" fill="#fff" width="18" height="18"><polygon points="8,5 19,12 8,19"/></svg></div>'+
        '</div>';
      }
    }
    html+='</div>';
  }

  html+='</div>';
  return html;
}

function buildBuyBoxes(redScores){
  if(!redScores||redScores.length===0)return'';
  var html='<div class="ha3__divider"></div>'+
    '<div class="ha3__buy-section">'+
    '<div class="ha3__buy-heading">Ready to take action?</div>'+
    '<div class="ha3__buy-sub">Dr. Martin formulated these specifically for the areas where your body needs the most support.</div>'+
    '<div class="ha3__buy-grid">';
  for(var i=0;i<redScores.length;i++){
    var s=redScores[i];
    var p=products[s.id];
    var handle=productHandles[s.id];
    if(!p||!handle)continue;
    var url='/products/'+handle;
    html+='<div class="ha3__buy-card">'+
      '<div class="ha3__buy-badge">Priority</div>'+
      '<div class="ha3__buy-img-wrap">'+
        '<img class="ha3__buy-img" src="'+(window.ha3ProductImages&&window.ha3ProductImages[handle]?window.ha3ProductImages[handle]:'/cdn/shop/products/'+handle+'_400x.jpg')+'" alt="'+p.name+'" loading="lazy">'+
      '</div>'+
      '<div class="ha3__buy-info">'+
        '<div class="ha3__buy-name">'+p.name+'</div>'+
        '<div class="ha3__buy-for">For your '+s.name+' score</div>'+
      '</div>'+
      '<a href="'+url+'" class="ha3__buy-btn">Shop Now &#8594;</a>'+
    '</div>';
  }
  html+='</div></div>';
  return html;
}

/* ─── Init ─── */
function init(){
  /* Wire up video modal close */
  bindClick('ha3-vid-close',closeVideoModal);
  bindClick('ha3-vid-backdrop',closeVideoModal);
  document.addEventListener('keydown',function(e){
    if(e.key==='Escape')closeVideoModal();
  });

  /* Check for saved progress */
  var saved=loadProgress();
  if(saved&&saved.gender){
    var resumeEl=$('ha3-resume');
    if(resumeEl)resumeEl.style.display='flex';
    bindClick('ha3-resume-fresh',function(){
      clearProgress();
      $('ha3-resume').style.display='none';
      renderGender();
    });
    bindClick('ha3-resume-continue',function(){
      restoreProgress(saved);
      $('ha3-resume').style.display='none';
      render();
    });
  } else {
    renderGender();
  }
}

init();
})();
